<template>
  <div class="importAccount">
    <div class="row-one">
      <i class="icon icon-warning"></i>
      <span v-html="topText" class="topText"></span>
      <el-button
        type="text"
        v-if="uploadError"
        @click="reUpload"
        class="reUpload"
        >重新上传</el-button
      >
    </div>
    <div v-show="!uploadError" class="row-two">
      <div class="box">
        <span class="label">请下载</span>
        <el-button type="primary" @click="downloadTemp">格式范例文档</el-button>
      </div>
      <div class="tip">
        请先下载账户格式范例文档根据指定格式导入，确保各字段类型数据正确无误，否则可能会导致导入账户失败。
      </div>
    </div>
    <div class="row-three" v-show="!uploadError">
      <div class="box">
        <span class="label">导入文件</span>
        <el-upload
          :action="action"
          :headers="headers"
          accept=".xls, .xlsx"
          class="upload-account"
          ref="upload"
          :auto-upload="false"
          :on-change="onChange"
          :on-remove="onChange"
          :on-success="onSuccess"
          :on-error="onError"
        >
          <el-button slot="trigger" size="small" type="primary"
            >点击上传</el-button
          >
          <div slot="tip" class="el-upload__tip">请导入.xls文件</div>
        </el-upload>
      </div>
    </div>
    <footer v-if="!uploadError">
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button @click="cancel">取消</el-button>
    </footer>
    <div v-if="uploadError" class="tableLabel">未通过账户</div>
    <el-table
      v-if="uploadError"
      :data="tableData"
      tooltip-effect="light"
      style="width: 100%"
    >
      <el-table-column
        label="账户名"
        prop="accountName"
        width="200px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="姓名"
        prop="userName"
        width="200px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="电子邮箱"
        prop="email"
        width="200px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="手机号码"
        prop="telephone"
        width="200px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="reason"
        label="未通过原因"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="uploadError"
      background
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :current-page.sync="page"
      :total="total"
      @current-change="pageChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        {
          label: "账户管理",
          url: "/userManage"
        },
        {
          label: "导入账户"
        }
      ],
      defaultText:
        "导入账户的密码为空时，平台将发送更新密码邮件至账户的关联邮箱里，为确保用户可以接收邮件，请确认已在系统设置中完成邮件配置。",
      topText: "",
      uploadError: false,
      hasFile: false,
      tableData: [],
      pageSize: 10,
      page: 1,
      total: 0,
      realmName: this.$realm,
      headers: {
        Authorization: `Bearer ${this.$keycloak.token}`
      },
      loading: null,
      tableStore: []
    }
  },
  computed: {
    action() {
      return `/idaas/admin/realms/${this.$realm}/users/usersUpload`
    }
  },
  mounted() {
    this.topText = this.defaultText
  },
  methods: {
    downloadTemp() {
      window.location.href = "/static/账户导入模板.xls"
    },
    // 分页改变
    pageChange() {
      let currentPageStart = (this.page - 1) * this.pageSize
      this.tableData = this.tableStore.slice(
        currentPageStart,
        currentPageStart + this.pageSize
      )
    },
    // 提交账户表格
    submit() {
      if (this.$refs.upload.uploadFiles.length === 0) {
        return false
      }
      this.loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      this.$refs.upload.submit()
    },
    cancel() {
      this.$router.push({
        path: "/userManage"
      })
    },
    // 文件上传成功
    onSuccess(response) {
      this.loading.close()
      let { status, data } = response
      if (status === 0) {
        if (data.data && data.data.length) {
          // data.data中有数据，则代表有异常账号
          this.uploadError = true
          this.topText = `导入失败！共检测到<i>${data.totalCount}</i>个账号，其中<i class='error'>${data.data.length}</i>个账号数据校验未通过，请处理后再上传。`
          // 存储数据，用于前端分页。该处前端实现分页更合适
          this.tableStore = data.data.map(account => ({
            accountName: account.accountname,
            userName: account.username,
            email: account.email,
            telephone: account.telephone,
            reason: account.info
          }))
          this.total = this.tableStore.length
          let currentPageStart = (this.page - 1) * this.pageSize
          this.tableData = this.tableStore.slice(
            currentPageStart,
            currentPageStart + this.pageSize
          )
        } else {
          this.$router.push({
            path: "/userManage"
          })
          this.$message.success({
            dangerouslyUseHTMLString: true,
            duration: 3000,
            message: `导入成功！共导入<i class='successAccount'>${data.totalCount}</i>个账户。`
          })
        }
      } else {
        this.uploadError = false
        this.$message.error({
          message: data
        })
      }
    },
    // 文件上传失败
    onError() {
      this.$message.error({
        message: "文件上传失败"
      })
    },
    // 文件状态改变
    onChange(file, fileList) {
      let nameArr = file && file.name && file.name.split(".")
      let sufix = nameArr[nameArr.length - 1]
      if (sufix === "xls" || sufix === "xlsx") {
        if (fileList.length) {
          this.hasFile = true
          if (fileList.length > 1) {
            this.$refs.upload.uploadFiles = [file]
          }
        } else {
          this.hasFile = false
        }
      } else {
        this.$message.error({
          message: "上传失败！请选择.xls文件"
        })
        this.$refs.upload.clearFiles()
      }
    },
    // 重新上传
    reUpload() {
      this.uploadError = false
      this.topText = this.defaultText
      this.hasFile = false
      this.tableStore = []
      this.tableData = []
      this.total = 0
      this.page = 1
      this.$refs.upload.clearFiles()
    }
  }
}
</script>

<style lang="scss">
.importAccount {
  font-size: 14px;
  .row-one {
    background-color: rgba(0, 112, 204, 0.05);
    height: 50px;
    padding: 0 15px;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #333333;
    .reUpload {
      color: #4497ec;
    }
    .icon-warning {
      margin-right: 8px;
    }
    .topText {
      i {
        font-style: normal;
        color: #4497ec;
        &.error {
          color: #d9001b;
        }
      }
    }
  }
  .row-two,
  .row-three {
    padding: 30px;
    border-bottom: 1px solid #ececec;
    .box {
      display: flex;
      // align-items: center;
      .label {
        width: 56px;
        line-height: 30px;
        display: inline-block;
      }
      .upload-account {
        .el-upload-list {
          margin-left: 15px;
          &__item {
            transition: none !important;
          }
        }
        .el-upload__tip {
          margin-left: 20px;
          color: #7f7f7f;
          font-size: 14px;
        }
      }
      .el-button {
        margin-left: 20px;
      }
    }
    .tip {
      color: #7f7f7f;
      height: 26px;
      margin-top: 10px;
      line-height: 26px;
    }
  }
  .row-three {
    border-bottom: none;
    height: 160px;
    overflow: hidden;
    .tip {
      padding-left: 76px;
    }
  }
  .tableLabel {
    height: 40px;
    display: flex;
    align-items: center;
    margin: 20px 0 6px;
    font-size: 15px;
    padding-left: 10px;
    position: relative;
    &::before {
      height: 26px;
      width: 4px;
      content: "";
      background-color: #4497ec;
      position: absolute;
      left: 0px;
    }
  }
  footer {
    padding-left: 106px;
  }
}
.el-message {
  .el-message__content {
    .successAccount {
      font-style: normal;
    }
  }
}
</style>
